import React, { useState } from "react";

// Material
import { Button } from "@mui/material";
import TaxConfigModal from "./taxConfig";

// Models
import { TaxConditionType } from "../../../../models/EnumEntity";

const TaxConfig = ({ customer, disabled }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleModalClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      {openModal && (
        <TaxConfigModal
          customer={customer}
          modalProps={{
            open: openModal,
            onClose: handleModalClose,
            maxWidth: "md",
          }}
        />
      )}
      <Button
        disabled={disabled ||
          ![TaxConditionType.RegisteredManager, TaxConditionType.Exempt, TaxConditionType.SingleTaxSystemPayer].includes(customer?.taxCondition)
        }
        fullWidth
        onClick={() => setOpenModal(true)}
        variant="outlined"
        color="primary"
        name='taxConfigButton'
      >
        Configuración impositiva ante Ingresos Brutos
      </Button>
    </>
  );
};

export default TaxConfig;
